import { motion } from 'framer-motion';
import { Hero3D } from './Hero3D';
import { HeroTagline } from './HeroTagline';
import { ArrowDown, Plane } from 'lucide-react';
import { scrollToSection } from './SmoothScroll';

export const HeroSection = () => {
  const scrollToServices = () => scrollToSection('servicios');

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#0A0A0A]" data-testid="hero-section">
      <Hero3D />
      
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-12 pt-24 pb-12 w-full">
        <div className="text-center">
          <HeroTagline />
          
          <motion.h1
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.3 }}
            className="font-display text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-light tracking-tight mb-6 sm:mb-8 leading-[1.05] sm:leading-[0.95]"
            data-testid="hero-title"
          >
            <span className="text-white">Marcas que</span>
            <br />
            <span className="italic font-medium text-gold-shimmer" style={{ paddingRight: '0.1em' }}>despegan</span>
            <span className="text-white">,</span>
            <br />
            <span className="text-white">resultados que</span>
            <br />
            <span className="italic font-medium" style={{ color: '#A93D52' }}>impactan</span>
            <span className="text-gold">.</span>
          </motion.h1>
          
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="font-sans text-sm sm:text-lg lg:text-xl text-white/60 max-w-2xl mx-auto mb-10 sm:mb-12 leading-relaxed px-2 sm:px-0"
            data-testid="hero-description"
          >
            Escalamos marcas a través de performance marketing impulsado por data, compra directa, programática y creatividad a través de múltiples canales digitales.
          </motion.p>
          
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            className="flex flex-col sm:flex-row items-center justify-center gap-4"
          >
            <button
              onClick={scrollToServices}
              className="group relative px-8 py-4 bg-gold text-black font-sans font-semibold rounded-full overflow-hidden transition-all duration-300 hover:shadow-2xl hover:shadow-gold/30 gold-glow"
              data-testid="hero-cta-primary"
            >
              <span className="relative z-10 flex items-center gap-2">
                Descubre nuestros servicios
                <Plane className="w-4 h-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
              </span>
            </button>
            <button
              onClick={() => scrollToSection('contacto')}
              className="group px-8 py-4 bg-white/[0.03] border border-white/10 text-white/90 font-sans font-medium rounded-full hover:border-gold hover:text-gold transition-all duration-300 backdrop-blur-md"
              data-testid="hero-cta-secondary"
            >
              Contáctanos
            </button>
          </motion.div>
        </div>
      </div>
      
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.5 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 cursor-pointer"
        onClick={scrollToServices}
        data-testid="hero-scroll-indicator"
      >
        <ArrowDown className="w-5 h-5 text-gold animate-bounce" />
      </motion.div>
    </section>
  );
};
